import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { useRoute } from 'vue-router'

export function useWindowWidth() {
  const windowWidth = ref<number>(typeof window !== 'undefined' ? window.innerWidth : 1024)

  const isMobile = computed(() => windowWidth.value < 768)

  const handleResize = (): void => {
    if (typeof window !== 'undefined') {
      windowWidth.value = window.innerWidth
    }
  }

  onMounted(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', handleResize)
    }
  })

  onBeforeUnmount(() => {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', handleResize)
    }
  })

  return {
    windowWidth,
    isMobile,
  }
}

export function useMobileDrawerMode(drawerType: 'login' | 'register' | 'settings') {
  const route = useRoute()
  const { isMobile } = useWindowWidth()

  const isMobileDrawerMode = computed(() => {
    return isMobile.value && route.query.drawer === drawerType
  })

  return {
    isMobileDrawerMode,
  }
}
